__turbopack_context__.v({
  "columnEditorItem": "SortableColumnItem-module__T8bNNW__columnEditorItem",
});
